/* ─── INITIALIZATION & NATIVE REGISTER ──────────────── */
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

document.addEventListener("DOMContentLoaded", () => {
  // Setup animations
  initAnimations();
  initHeaderScroll();
  initProductHoverSlideshow();

  // Start typewriter if target exists
  if (document.getElementById("typewriter")) {
    typeEffect();
  }
  
  // Start countdown
  initCountdownTimer();
  
  // Initialize Fullscreen Video Slider
  initFullscreenVideoSlider();

  // Fetch real cart count on page load so badge is always correct
  initCartBadge();
  

  // Native Intersection Observer for Scroll Reveals
  const revealCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target);
      }
    });
  };

  const revealObserver = new IntersectionObserver(revealCallback, {
    root: null,
    threshold: 0.12,
    rootMargin: "0px 0px -40px 0px"
  });

  document.querySelectorAll(".reveal").forEach(element => {
    revealObserver.observe(element);
  });

  // Size Swatches Toggle Click Listener
  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(".size-swatch");
    if (swatch && !swatch.classList.contains("disabled")) {
      const swatchesContainer = swatch.closest(".size-swatches");
      const card = swatch.closest(".product-card, .hero-featured-card, .hotspot-card");
      if (swatchesContainer) {
        swatchesContainer.querySelectorAll(".size-swatch").forEach(s => s.classList.remove("active"));
        swatch.classList.add("active");
      }

      if (card) {
        const variantId = swatch.getAttribute("data-variant-id");
        const quickAddBtn = card.querySelector(".btn-quick-add, .hfc-btn-quick");
        const isAvailable = swatch.getAttribute("data-available") !== "false";
        const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');

        if (variantId && quickAddBtn) {
          quickAddBtn.setAttribute("data-variant-id", variantId);
        }

        if (quickAddBtn) {
          if (!isAvailable) {
            quickAddBtn.disabled = true;
            quickAddBtn.classList.add("disabled");
            quickAddBtn.textContent = isEn ? "Out of Stock ⏳" : "نفد من المخزن ⏳";
            quickAddBtn.style.backgroundColor = "#222";
            quickAddBtn.style.color = "#777";
            quickAddBtn.style.cursor = "not-allowed";
          } else {
            quickAddBtn.disabled = false;
            quickAddBtn.classList.remove("disabled");
            quickAddBtn.textContent = isEn ? "Add to Cart 🛒" : "شراء سريع 🛒";
            quickAddBtn.style.backgroundColor = "";
            quickAddBtn.style.color = "";
            quickAddBtn.style.cursor = "";
          }
        }
      }
    }
  });

  // ─── AJAX Add to Cart — Intercept product form submit ───────────
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form.product-buy-form");
    if (!form) return;

    e.preventDefault();

    const variantId = form.querySelector('[name="id"]')?.value;
    const quantity  = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
    const btn       = form.querySelector('#AddToCart');
    const btnText   = btn?.querySelector('#AddToCartText');

    if (!variantId) return;

    // Loading state
    if (btn) {
      btn.disabled = true;
      if (btnText) btnText.textContent = window.location.pathname.startsWith('/en') ? 'Adding…' : 'جاري الإضافة…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity })
    })
    .then(res => {
      if (!res.ok) return res.json().then(d => { throw new Error(d.description || 'Error'); });
      return res.json();
    })
    .then(() => {
      openCartDrawer();
      renderCart();
    })
    .catch(err => {
      console.error('Add to Cart error:', err);
      showThemeToast(err.message || (window.location.pathname.startsWith('/en') ? 'This size is out of stock.' : 'نفد المخزون لهذا المقاس.'));
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        if (btnText) {
          const isEn = window.location.pathname.startsWith('/en');
          btnText.textContent = isEn ? 'Add to Cart 🛒' : 'أضف للسلة 🛒';
        }
      }
    });
  });
});


/* ─── STICKY BAR ADD TO CART ──────────────────────── */
function submitProductFormFromSticky() {
  const variantId = document.getElementById('ProductVariantId')?.value;
  const quantity  = parseInt(document.getElementById('StickyProductQuantity')?.value || 1);
  const btn       = document.getElementById('StickyAddToCartBtn');
  const isEn      = window.location.pathname.startsWith('/en');

  if (!variantId) return;

  if (btn) {
    btn.disabled = true;
    btn.textContent = isEn ? 'Adding…' : 'جاري الإضافة…';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity })
  })
  .then(res => {
    if (!res.ok) return res.json().then(d => { throw new Error(d.description || 'Error'); });
    return res.json();
  })
  .then(() => {
    openCartDrawer();
    renderCart();
  })
  .catch(err => {
    console.error('Sticky Add to Cart error:', err);
    showThemeToast(err.message || (isEn ? 'This size is out of stock.' : 'نفد المخزون لهذا المقاس.'));
  })
  .finally(() => {
    if (btn) {
      btn.disabled = false;
      btn.textContent = isEn ? 'Add to Cart 🛒' : 'أضف للسلة 🛒';
    }
  });
}

/* ─── GSAP ENTRANCE ANIMATIONS ─────────────────────── */

function initAnimations() {
  // Hero Entrance
  const tlHero = gsap.timeline({ defaults: { ease: "power3.out", duration: 1 } });
  
  tlHero.from(".badge", { opacity: 0, y: 15, delay: 0.2 })
        .from(".hero-title", { opacity: 0, y: 25 }, "-=0.7")
        .from(".hero-subtitle", { opacity: 0, y: 20 }, "-=0.7")
        .from(".hero-actions .btn-primary", { opacity: 0, y: 15, clearProps: "all" }, "-=0.6")
        .from(".hero-actions .btn-ghost", { opacity: 0, y: 15, clearProps: "all" }, "-=0.8")
        .from(".hero-featured-card", { opacity: 0, y: 35, scale: 0.95, duration: 1.2 }, "-=0.4");
}

/* ─── HEADER SCROLL DYNAMICS ───────────────────────── */
function initHeaderScroll() {
  const header = document.getElementById("SiteHeader");
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 120) {
      header.classList.add("sticky-header");
      
      // Hide on scroll down, show on scroll up
      if (currentScroll > lastScroll) {
        header.style.transform = "translateY(-100%)";
      } else {
        header.style.transform = "translateY(0)";
      }
    } else {
      header.classList.remove("sticky-header");
      header.style.transform = "translateY(0)";
    }
    
    lastScroll = currentScroll;
  });
}




/* ─── SEARCH TOGGLE ────────────────────────────────── */
function toggleSearch() {
  const searchOverlay = document.getElementById("SearchOverlay");
  searchOverlay.classList.toggle("active");
}

/* ─── CART DRAWER SIMULATOR ────────────────────────── */
let cart = [];

function openCartDrawer() {
  const drawer = document.getElementById("CartDrawer");
  if (!drawer) return;
  drawer.classList.add("active");
  drawer.setAttribute("aria-hidden", "false");
  renderCart();
}

function closeCartDrawer() {
  const drawer = document.getElementById("CartDrawer");
  if (!drawer) return;
  drawer.classList.remove("active");
  drawer.setAttribute("aria-hidden", "true");
}

function quickAddToCart(productId, title, price, element) {
  let targetVariantId = productId;
  if (element) {
    const card = element.closest(".product-card, .hero-featured-card, .hotspot-card");
    if (card) {
      const activeSwatch = card.querySelector(".size-swatch.active");
      if (activeSwatch && activeSwatch.getAttribute("data-variant-id")) {
        targetVariantId = activeSwatch.getAttribute("data-variant-id");
      } else if (element.getAttribute("data-variant-id")) {
        targetVariantId = element.getAttribute("data-variant-id");
      }
    }
  }

  // If it's a numeric ID (real Shopify Variant ID)
  if (targetVariantId && !isNaN(targetVariantId)) {
    let originalText = "";
    if (element) {
      originalText = element.textContent;
      const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
      element.textContent = isEn ? "Adding... ⏳" : "جاري الإضافة... ⏳";
      element.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(targetVariantId),
          quantity: 1
        }]
      })
    })
    .then(res => {
      if (!res.ok) {
        return res.json().then(errData => {
          throw new Error(errData.description || 'عذراً، هذا المنتج غير متوفر حالياً.');
        });
      }
      return res.json();
    })
    .then(() => {
      if (element) {
        const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
        element.textContent = isEn ? "Added! 🎉" : "تمت الإضافة! 🎉";
        element.style.backgroundColor = "#def71d";
        element.style.color = "#0a0a0a";
        setTimeout(() => {
          element.textContent = originalText;
          element.disabled = false;
          element.style.backgroundColor = "";
          element.style.color = "";
        }, 1500);
      }
      openCartDrawer();
    })
    .catch(err => {
      // Inline visual feedback instead of raw browser alert
      if (element) {
        element.textContent = "نفد من المخزن ⏳";
        element.style.backgroundColor = "#222";
        element.style.color = "#777";
        setTimeout(() => {
          element.textContent = originalText;
          element.disabled = false;
          element.style.backgroundColor = "";
          element.style.color = "";
        }, 3000);
      }
      console.error("Error in quickAddToCart AJAX:", err);
    });
    return;
  }

  // Fallback local simulated cart for testing/preview page
  let selectedSize = "";
  if (element) {
    const card = element.closest(".product-card, .hero-featured-card, .hotspot-card");
    if (card) {
      const activeSwatch = card.querySelector(".size-swatch.active");
      if (activeSwatch) {
        selectedSize = activeSwatch.textContent.trim();
      }
    }
  }

  const cartItemId = selectedSize ? `${productId}-${selectedSize}` : productId;
  const finalTitle = selectedSize ? `${title} (${selectedSize})` : title;

  const existingItem = cart.find(item => item.cartItemId === cartItemId);
  
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    let emoji = "👕";
    if (title.toLowerCase().includes("leggings")) emoji = "🧘‍♀️";
    if (title.toLowerCase().includes("shorts")) emoji = "🩳";
    
    cart.push({
      id: productId,
      cartItemId: cartItemId,
      title: finalTitle,
      price: parseFloat(price),
      quantity: 1,
      emoji: emoji
    });
  }
  
  updateCartBadge();
  openCartDrawer();
}

function removeFromCart(cartItemId) {
  cart = cart.filter(item => item.cartItemId !== cartItemId);
  updateCartBadge();
  renderCart();
}

function updateCartBadge(count) {
  const badge = document.getElementById("CartBadge");
  if (badge) {
    if (typeof count !== 'undefined') {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    } else {
      const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
      badge.textContent = totalItems;
      badge.style.display = totalItems > 0 ? 'flex' : 'none';
    }
  }
}

function initCartBadge() {
  // Only fetch on Shopify live store (not local preview)
  if (!window.Shopify && !window.location.hostname.includes('myshopify') && !window.location.hostname.includes('8fluidity')) return;
  fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      updateCartBadge(cartData.item_count);
    })
    .catch(() => {}); // silently fail on local/preview
}

function renderCart() {
  const itemsContainer = document.getElementById("CartDrawerItems");
  const totalContainer = document.getElementById("CartDrawerTotal");
  if (!itemsContainer || !totalContainer) return;

  // Check if we are running in the Shopify live store or local HTML preview
  const isShopify = window.Shopify || window.location.pathname.includes('/products') || window.location.pathname.includes('/cart');

  if (isShopify) {
    // Shopify Live: Fetch dynamic cart items
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        updateCartBadge(cartData.item_count);
        
        if (cartData.items.length === 0) {
          itemsContainer.innerHTML = `<p class="cart-empty-message">سلتك فارغة حالياً.</p>`;
          totalContainer.textContent = formatMoney(0);
          return;
        }

        let html = "";
        cartData.items.forEach(item => {
          let optionsText = "";
          if (item.options_with_values && item.options_with_values.length > 0) {
            optionsText = item.options_with_values.map(opt => `${opt.name}: ${opt.value}`).join(' | ');
          }

          html += `
            <div class="drawer-item" style="display: flex; align-items: center; gap: 1rem; padding: 1rem 0; border-bottom: 1px solid var(--color-border);">
              <div class="drawer-item-emoji">
                <img src="${item.image ? item.image : ''}" alt="${item.title}" style="width: 55px; height: 55px; object-fit: cover; border-radius: var(--radius-sm); border: 1px solid var(--color-border); background: var(--color-bg-alt);">
              </div>
              <div class="drawer-item-details" style="flex-grow: 1; display: flex; flex-direction: column; gap: 0.25rem;">
                <span class="drawer-item-title" style="font-weight: 700; font-size: 0.95rem; color: var(--color-text);">${item.product_title}</span>
                ${optionsText ? `<span style="font-size: 0.8rem; color: var(--color-text-muted);">${optionsText}</span>` : ''}
                <span class="drawer-item-price" style="color: var(--color-accent); font-weight: 700; font-size: 0.9rem; display: flex; justify-content: space-between; align-items: center;">
                  <span>${item.quantity} × ${formatMoney(item.original_price)}</span>
                  <button class="drawer-item-remove" onclick="removeRealCartItem('${item.key}')" style="background: transparent; border: none; color: #ff4d4d; font-family: var(--font-ar); font-size: 0.8rem; cursor: pointer; text-decoration: underline;">إزالة</button>
                </span>
              </div>
            </div>
          `;
        });

        itemsContainer.innerHTML = html;
        totalContainer.textContent = formatMoney(cartData.total_price);
      })
      .catch(err => {
        console.error("Error fetching Shopify cart:", err);
      });
  } else {
    // Local HTML Mock Preview
    if (cart.length === 0) {
      itemsContainer.innerHTML = `<p class="cart-empty-message">سلتك فارغة حالياً.</p>`;
      totalContainer.textContent = "0.00 ر.س";
      return;
    }
    
    let html = "";
    let total = 0;
    
    cart.forEach(item => {
      const itemTotal = item.price * item.quantity;
      total += itemTotal;
      
      html += `
        <div class="drawer-item" style="display: flex; align-items: center; gap: 1rem; padding: 1rem 0; border-bottom: 1px solid var(--color-border);">
          <div class="drawer-item-emoji" style="font-size: 1.8rem;">${item.emoji}</div>
          <div class="drawer-item-details" style="flex-grow: 1; display: flex; flex-direction: column; gap: 0.25rem;">
            <span class="drawer-item-title" style="font-weight: 700; font-size: 0.95rem; color: var(--color-text);">${item.title} (x${item.quantity})</span>
            <span class="drawer-item-price" style="color: var(--color-accent); font-weight: 700; font-size: 0.9rem; display: flex; justify-content: space-between; align-items: center;">
              <span>${itemTotal.toFixed(2)} ر.س</span>
              <button class="drawer-item-remove" onclick="removeFromCart('${item.cartItemId}')" style="background: transparent; border: none; color: #ff4d4d; font-family: var(--font-ar); font-size: 0.8rem; cursor: pointer; text-decoration: underline;">إزالة</button>
            </span>
          </div>
        </div>
      `;
    });
    
    itemsContainer.innerHTML = html;
    totalContainer.textContent = `${total.toFixed(2)} ر.س`;
  }
}

function removeRealCartItem(itemKey) {
  const itemsContainer = document.getElementById("CartDrawerItems");
  if (itemsContainer) {
    itemsContainer.innerHTML = `<p class="cart-empty-message" style="text-align: center; color: var(--color-text-muted);">جاري التحديث... ⏳</p>`;
  }
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  })
  .then(res => res.json())
  .then(cartData => {
    renderCart();
  })
  .catch(err => console.error("Error removing Shopify cart item:", err));
}

function scrollToSection(selector, e) {
  if (e) e.preventDefault();
  const section = document.querySelector(selector);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
}

function scrollToProducts(e) {
  scrollToSection('[id^="featured-products-section"]', e);
}

// Intercept Navigation Links dynamically
document.addEventListener("DOMContentLoaded", () => {
  // Handle URL hash on load
  if (window.location.hash) {
    setTimeout(() => {
      if (window.location.hash === "#offers") {
        scrollToSection("#countdown-banner-section");
      }
    }, 800);
  }
});






/* ─── TYPEWRITER EFFECT ────────────────────────────── */
const typewriterWords = window.typewriterWords || [
  "لا يقبل المساومة.",
  "يتجاوز كل الحدود.",
  "يدعم حركتك الحرة.",
  "مستدام صديق للبيئة."
];
const typewriterHighlights = window.typewriterHighlights || [
  "المساومة",
  "الحدود",
  "الحرة",
  "مستدام"
];
let wordIndex = 0;
let charIndex = 0;
let isDeleting = false;
let typewriterTimer = null;

function typeEffect() {
  const typewriterEl = document.getElementById("typewriter");
  if (!typewriterEl) return;

  const currentWord = typewriterWords[wordIndex];
  
  if (isDeleting) {
    charIndex--;
  } else {
    charIndex++;
  }
  
  let typedText = currentWord.substring(0, charIndex);
  
  // Highlight words dynamically using a regex match
  if (typewriterHighlights && typewriterHighlights.length > 0) {
    typewriterHighlights.forEach(word => {
      const trimmedWord = word.trim();
      if (trimmedWord) {
        const regex = new RegExp(`(${trimmedWord})`, 'g');
        typedText = typedText.replace(regex, '<span style="color: var(--color-accent);">$1</span>');
      }
    });
  }
  
  typewriterEl.innerHTML = typedText;
  
  let typeSpeed = isDeleting ? 40 : 100;
  
  if (!isDeleting && charIndex === currentWord.length) {
    typeSpeed = 2000;
    isDeleting = true;
  } else if (isDeleting && charIndex === 0) {
    isDeleting = false;
    wordIndex = (wordIndex + 1) % typewriterWords.length;
    typeSpeed = 400;
  }
  
  typewriterTimer = setTimeout(typeEffect, typeSpeed);
}

/* ─── FABRIC TECH SHOWCASE TABS ACCORDION ──────────── */
function activateTechTab(techId) {
  const items = document.querySelectorAll(".tech-accordion-item");
  items.forEach(item => {
    item.classList.remove("active");
  });
  
  const activeItem = document.querySelector(`.tech-accordion-item[data-tech-id="${techId}"]`);
  if (activeItem) {
    activeItem.classList.add("active");
  }
  
  const graphics = document.querySelectorAll(".tech-graphic-wrapper");
  graphics.forEach(graphic => {
    graphic.classList.remove("active");
  });
  
  const targetGraphic = document.getElementById(`graphic-${techId}`);
  if (targetGraphic) {
    targetGraphic.classList.add("active");
    gsap.fromTo(targetGraphic.querySelector(".fabric-wave-svg"), 
      { scale: 0.9, opacity: 0.5 }, 
      { scale: 1, opacity: 1, duration: 0.6, ease: "back.out(1.5)" }
    );
  }
}

/* ─── SHOP THE LOOK HOTSPOTS ───────────────────────── */
function toggleHotspotCard(index) {
  const hotspots = document.querySelectorAll(".hotspot");
  
  hotspots.forEach((hotspot) => {
    const card = hotspot.querySelector(".hotspot-card");
    if (!card) return;
    const cardId = card.id;
    if (cardId === `hotspot-card-${index}`) {
      hotspot.classList.toggle("active");
    } else {
      hotspot.classList.remove("active");
    }
  });
  
  document.addEventListener("click", function closeOutside(e) {
    if (!e.target.closest(".hotspot")) {
      hotspots.forEach(h => h.classList.remove("active"));
      document.removeEventListener("click", closeOutside);
    }
  });
}

/* ─── TESTIMONIALS SLIDER ──────────────────────────── */
let currentSlide = 0;

function slideTestimonials(direction) {
  const track = document.getElementById("testimonialsTrack");
  const slides = document.querySelectorAll(".testimonial-card");
  if (!track || slides.length === 0) return;
  
  currentSlide = (currentSlide + direction + slides.length) % slides.length;
  
  const isRtl = document.documentElement.getAttribute("dir") === "rtl";
  const offset = isRtl ? (currentSlide * 100) : -(currentSlide * 100);
  
  track.style.transform = `translateX(${offset}%)`;
}

/* ─── COUNTDOWN TIMER ─────────────────────────────── */
function initCountdownTimer() {
  const section = document.getElementById("countdown-banner-section");
  if (!section) return;
  const endDateStr = (section.getAttribute("data-end-date") || "").trim();
  const autoRenew = section.getAttribute("data-auto-renew") === "true";
  const renewDays = parseInt(section.getAttribute("data-renew-days") || "5", 10) || 5;
  
  const timerDays = document.getElementById("timer-days");
  const timerHours = document.getElementById("timer-hours");
  const timerMinutes = document.getElementById("timer-minutes");
  const timerSeconds = document.getElementById("timer-seconds");
  
  if (!timerDays) return;
  
  let targetDate;
  if (endDateStr) {
    // If format is YYYY-MM-DD, set to end of that day (23:59:59)
    if (/^\d{4}-\d{2}-\d{2}$/.test(endDateStr)) {
      targetDate = new Date(endDateStr + "T23:59:59");
    } else {
      targetDate = new Date(endDateStr);
    }
  } else {
    targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + renewDays);
  }
  
  if (isNaN(targetDate.getTime())) {
    targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + renewDays);
  }
  
  const renewMs = renewDays * 24 * 60 * 60 * 1000;
  
  // Calculate if target date is in the past and auto-renew is enabled
  let now = new Date().getTime();
  if (targetDate.getTime() <= now && autoRenew) {
    const elapsed = now - targetDate.getTime();
    const cyclesToAdd = Math.floor(elapsed / renewMs) + 1;
    targetDate = new Date(targetDate.getTime() + (cyclesToAdd * renewMs));
  }
  
  function updateTimer() {
    now = new Date().getTime();
    let difference = targetDate.getTime() - now;
    
    if (difference <= 0) {
      if (autoRenew) {
        const elapsed = now - targetDate.getTime();
        const cyclesToAdd = Math.floor(elapsed / renewMs) + 1;
        targetDate = new Date(targetDate.getTime() + (cyclesToAdd * renewMs));
        difference = targetDate.getTime() - now;
      } else {
        timerDays.textContent = '00';
        timerHours.textContent = '00';
        timerMinutes.textContent = '00';
        timerSeconds.textContent = '00';
        clearInterval(timerInterval);
        return;
      }
    }
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    
    timerDays.textContent = String(days).padStart(2, '0');
    timerHours.textContent = String(hours).padStart(2, '0');
    timerMinutes.textContent = String(minutes).padStart(2, '0');
    timerSeconds.textContent = String(seconds).padStart(2, '0');
  }
  
  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
}

/* ─── FULLSCREEN SCROLL VIDEO SLIDER ───────────────── */
function initFullscreenVideoSlider() {
  const section = document.querySelector(".section-fullscreen-video-slider");
  if (!section) return;

  const track = section.querySelector(".scroll-track-container");
  const videos = section.querySelectorAll(".bg-slide-video");
  const texts = section.querySelectorAll(".slide-text-block");
  const dots = section.querySelectorAll(".pagination-dot");

  function setActiveSlide(index) {
    videos.forEach((v, i) => v.classList.toggle("active", i === index));
    texts.forEach((t, i) => t.classList.toggle("active", i === index));
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
  }

  function handleVideoSliderScroll() {
    const sectionRect = track.getBoundingClientRect();
    const sectionHeight = sectionRect.height;
    const windowHeight = window.innerHeight;
    const scrolledAmount = -sectionRect.top;
    const scrollableDistance = sectionHeight - windowHeight;

    if (scrollableDistance <= 0) return;

    let progress = scrolledAmount / scrollableDistance;
    progress = Math.max(0, Math.min(1, progress));

    // Determine active index (0, 1, or 2)
    let activeIndex = 0;
    if (progress > 0.33 && progress <= 0.66) {
      activeIndex = 1;
    } else if (progress > 0.66) {
      activeIndex = 2;
    }

    setActiveSlide(activeIndex);
  }

  // Initial trigger
  setActiveSlide(0);
  handleVideoSliderScroll();
  window.addEventListener("scroll", handleVideoSliderScroll);
}


/* ─── FAQ ACCORDION ────────────────────────────────── */
function toggleFaq(index) {
  const faqItems = document.querySelectorAll(".faq-item");
  faqItems.forEach((item, i) => {
    if (i === index) {
      const isActive = item.classList.contains("active");
      if (isActive) {
        item.classList.remove("active");
        const answer = item.querySelector(".faq-answer");
        if (answer) answer.style.maxHeight = null;
      } else {
        item.classList.add("active");
        const answer = item.querySelector(".faq-answer");
        if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
      }
    } else {
      item.classList.remove("active");
      const answer = item.querySelector(".faq-answer");
      if (answer) answer.style.maxHeight = null;
    }
  });
}

/* ─── PRODUCT HOVER SLIDESHOW ──────────────────────── */
function initProductHoverSlideshow() {
  const slideshows = document.querySelectorAll(".product-hover-slideshow");
  
  slideshows.forEach(slideshow => {
    const images = slideshow.querySelectorAll(".product-slideshow-img");
    if (images.length <= 1) return;
    
    let intervalId = null;
    let currentIndex = 0;
    
    slideshow.addEventListener("mouseenter", () => {
      intervalId = setInterval(() => {
        images[currentIndex].classList.remove("active");
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].classList.add("active");
      }, 1200);
    });
    
    slideshow.addEventListener("mouseleave", () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      images.forEach((img, idx) => {
        if (idx === 0) {
          img.classList.add("active");
        } else {
          img.classList.remove("active");
        }
      });
      currentIndex = 0;
    });
  });
}

/* ─── PRODUCT DETAIL PAGE CONTROLS ─────────────────── */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductPage);
} else {
  initProductPage();
}

// Re-initialize when section is refreshed in Shopify Theme Editor (Customizer)
document.addEventListener("shopify:section:load", (event) => {
  if (event.detail.sectionId === 'main-product' || event.target.querySelector('.section-main-product')) {
    initProductPage();
  }
});

function initProductPage() {
  // 1. Gallery thumbnails hover/click
  const thumbnails = document.querySelectorAll(".thumbnail-btn");
  const mainImage = document.getElementById("ProductMainImage");
  
  thumbnails.forEach(thumb => {
    thumb.addEventListener("click", () => {
      thumbnails.forEach(t => t.classList.remove("active"));
      thumb.classList.add("active");
      const newUrl = thumb.getAttribute("data-image-url");
      if (mainImage && newUrl) {
        mainImage.src = newUrl;
      }
    });
  });

  // 2. Swatch variant picker selection
  const swatchGroups = document.querySelectorAll(".variant-option-group");
  const variantJsonEl = document.getElementById("ProductVariantData-" + (document.querySelector(".section-main-product")?.getAttribute("id")?.replace("MainProduct-", "") || ""));
  
  if (swatchGroups.length > 0 && variantJsonEl) {
    const variants = JSON.parse(variantJsonEl.textContent);
    const swatchBtns = document.querySelectorAll(".swatch-btn");

    swatchBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        const group = btn.closest(".variant-option-group");
        group.querySelectorAll(".swatch-btn").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        
        // Find selected options
        const selectedOptions = [];
        document.querySelectorAll(".variant-option-group").forEach(g => {
          const activeBtn = g.querySelector(".swatch-btn.active");
          if (activeBtn) {
            selectedOptions.push(activeBtn.getAttribute("data-value"));
          }
        });

        // Find matching variant
        const matchedVariant = variants.find(variant => {
          return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
        });

        if (matchedVariant) {
          // Update hidden input ID
          const inputVal = document.getElementById("ProductVariantId");
          if (inputVal) inputVal.value = matchedVariant.id;

          // Update main price
          const priceContainer = document.querySelector(".product-price-wrapper");
          if (priceContainer) {
            const showDiscount = priceContainer.getAttribute("data-show-discount") !== "false";
            const discountPct = parseInt(priceContainer.getAttribute("data-discount-percent") || "20", 10);
            const currentPriceEl = priceContainer.querySelector(".price-current");
            const comparePriceEl = priceContainer.querySelector(".price-compare");
            let discountEl = priceContainer.querySelector(".price-discount-tag");
            const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');

            let finalPrice = matchedVariant.price;
            let strikePrice = null;
            let actualPct = 0;

            if (showDiscount && discountPct > 0) {
              if (matchedVariant.compare_at_price > matchedVariant.price) {
                finalPrice = matchedVariant.price;
                strikePrice = matchedVariant.compare_at_price;
                actualPct = Math.round(((strikePrice - finalPrice) * 100) / strikePrice);
              } else {
                strikePrice = matchedVariant.price;
                finalPrice = Math.round(matchedVariant.price * (100 - discountPct) / 100);
                actualPct = discountPct;
              }
            } else {
              if (matchedVariant.compare_at_price > matchedVariant.price) {
                finalPrice = matchedVariant.price;
                strikePrice = matchedVariant.compare_at_price;
                actualPct = Math.round(((strikePrice - finalPrice) * 100) / strikePrice);
              }
            }

            if (currentPriceEl) currentPriceEl.textContent = formatMoney(finalPrice);
            
            if (strikePrice && strikePrice > finalPrice) {
              if (comparePriceEl) {
                comparePriceEl.textContent = formatMoney(strikePrice);
                comparePriceEl.style.display = 'inline';
              }
              if (!discountEl && comparePriceEl) {
                discountEl = document.createElement("span");
                discountEl.className = "price-discount-tag";
                priceContainer.appendChild(discountEl);
              }
              if (discountEl) {
                discountEl.textContent = isEn ? `Save ${actualPct}% ⚡` : `وفر ${actualPct}% ⚡`;
                discountEl.style.display = 'inline-block';
              }
            } else {
              if (comparePriceEl) comparePriceEl.style.display = 'none';
              if (discountEl) discountEl.style.display = 'none';
            }
          }

          // Update main Add to Cart state
          const addToCartBtn = document.getElementById("AddToCart");
          const addToCartText = document.getElementById("AddToCartText");
          const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
          if (addToCartBtn && addToCartText) {
            if (matchedVariant.available) {
              addToCartBtn.classList.remove("disabled");
              addToCartText.textContent = isEn ? "Add to Cart 🛒" : "أضف للسلة 🛒";
            } else {
              addToCartBtn.classList.add("disabled");
              addToCartText.textContent = isEn ? "Out of Stock ❌" : "نفد من المخزن ❌";
            }
          }


          // Update Frequently Bought Together main item price too
          const mainItemPrice = document.querySelector(".current-product-row .item-price");
          if (mainItemPrice) {
            mainItemPrice.setAttribute("data-price", matchedVariant.price);
            mainItemPrice.textContent = formatMoney(matchedVariant.price);
            updateBundleTotal();
          }

          // Update main image if variant has image
          if (matchedVariant.featured_image && mainImage) {
            mainImage.src = matchedVariant.featured_image.src;
          }
        }
      });
    });
  }

  // 3. Initialize current variant button and elements state on page load
  if (variantJsonEl) {
    const variants = JSON.parse(variantJsonEl.textContent);
    const selectedOptions = [];
    document.querySelectorAll(".variant-option-group").forEach(g => {
      const activeBtn = g.querySelector(".swatch-btn.active");
      if (activeBtn) {
        selectedOptions.push(activeBtn.getAttribute("data-value"));
      }
    });

    const matchedVariant = variants.find(variant => {
      return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (matchedVariant) {
      const addToCartBtn = document.getElementById("AddToCart");
      const addToCartText = document.getElementById("AddToCartText");
      const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
      if (addToCartBtn && addToCartText) {
        if (matchedVariant.available) {
          addToCartBtn.classList.remove("disabled");
          addToCartText.textContent = isEn ? "Add to Cart 🛒" : "أضف للسلة 🛒";
        } else {
          addToCartBtn.classList.add("disabled");
          addToCartText.textContent = isEn ? "Out of Stock ❌" : "نفد من المخزن ❌";
        }
      }
    }
  }

  // 4. Initialize Bundle Total
  updateBundleTotal();

  // Listen for Frequently Bought Together checkbox changes
  const checkboxes = document.querySelectorAll(".bundle-checkbox");
  checkboxes.forEach(cb => {
    cb.addEventListener("change", updateBundleTotal);
  });

  // Listen for Frequently Bought Together variant changes
  const variantSelectors = document.querySelectorAll(".bundle-variant-selector");
  variantSelectors.forEach(sel => {
    sel.addEventListener("change", (e) => {
      const option = sel.options[sel.selectedIndex];
      const newPrice = option.getAttribute("data-price");
      const priceDisplay = sel.closest(".bundle-item-row").querySelector(".item-price");
      if (priceDisplay && newPrice) {
        priceDisplay.setAttribute("data-price", newPrice);
        priceDisplay.textContent = formatMoney(parseInt(newPrice));
      }
      updateBundleTotal();
    });
  });
}


// 4. Quantity Adjuster helper
function adjustProductQty(amount) {
  const qtyInput = document.getElementById("ProductQuantity");
  if (!qtyInput) return;
  let currentVal = parseInt(qtyInput.value) || 1;
  currentVal += amount;
  if (currentVal < 1) currentVal = 1;
  qtyInput.value = currentVal;
}

// 5. Accordion slide helper
function toggleProductAccordion(header) {
  const item = header.closest(".product-accordion-item");
  const isActive = item.classList.contains("active");
  
  // Close all other items
  document.querySelectorAll(".product-accordion-item").forEach(i => {
    i.classList.remove("active");
    i.querySelector(".accordion-content").style.maxHeight = null;
  });

  if (!isActive) {
    item.classList.add("active");
    const content = item.querySelector(".accordion-content");
    content.style.maxHeight = content.scrollHeight + "px";
  }
}

// 6. Frequently Bought Together Pricing updates
function updateBundleTotal() {
  const totalDisplay = document.getElementById("BundleTotalPrice");
  if (!totalDisplay) return;

  const bundleContainer = document.querySelector(".frequently-bought-together");
  const discountPercent = bundleContainer ? parseInt(bundleContainer.getAttribute("data-discount-percent") || 15) : 15;

  let totalPrice = 0;
  
  // Current main item
  const mainChecked = document.getElementById("bundle-item-main");
  if (mainChecked && mainChecked.checked) {
    const mainPriceEl = document.querySelector(".current-product-row .item-price");
    if (mainPriceEl) {
      totalPrice += parseInt(mainPriceEl.getAttribute("data-price") || 0);
    }
  }

  // Complementary items
  document.querySelectorAll(".complementary-row").forEach(row => {
    const checkbox = row.querySelector(".bundle-checkbox");
    if (checkbox && checkbox.checked) {
      const priceEl = row.querySelector(".item-price");
      if (priceEl) {
        totalPrice += parseInt(priceEl.getAttribute("data-price") || 0);
      }
    }
  });

  // Calculate dynamic discount percentage
  const discountFactor = (100 - discountPercent) / 100;
  const finalDiscountedPrice = Math.round(totalPrice * discountFactor);

  totalDisplay.innerHTML = `
    <span class="old-total-strike">${formatMoney(totalPrice)}</span>
    <span class="new-bundle-price">${formatMoney(finalDiscountedPrice)}</span>
  `;
}

// 7. Add full bundle to cart via AJAX API
function addBundleToCart() {
  const items = [];
  
  // Main Product Selected Variant ID
  const mainVariantId = document.getElementById("ProductVariantId")?.value;
  const mainChecked = document.getElementById("bundle-item-main");
  if (mainChecked && mainChecked.checked && mainVariantId) {
    items.push({ id: parseInt(mainVariantId), quantity: 1 });
  }

  let validationError = false;

  // Complementary items
  document.querySelectorAll(".complementary-row").forEach(row => {
    const checkbox = row.querySelector(".bundle-checkbox");
    if (checkbox && checkbox.checked) {
      // Find variant ID
      const variantSel = row.querySelector(".bundle-variant-selector");
      let variantId = null;
      if (variantSel) {
        variantId = variantSel.value;
      } else {
        // Fallback to hidden selector if any, or default first option
        const select = row.querySelector("select");
        if (select) variantId = select.value;
      }
      
      if (variantId) {
        items.push({ id: parseInt(variantId), quantity: 1 });
      } else {
        validationError = true;
      }
    }
  });

  if (validationError) {
    const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
    showThemeToast(isEn ? "Please select sizes for all products in the bundle first 👇" : "فضلاً حدد المقاسات المطلوبة لكل منتج في الباقة أولاً 👇");
    return;
  }

  if (items.length === 0) return;

  const bundleContainer = document.querySelector(".frequently-bought-together");
  const discountCode = bundleContainer ? bundleContainer.getAttribute("data-discount-code") : '';
  const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');

  const bundleBtn = document.querySelector(".bundle-add-btn");
  const oldText = bundleBtn.textContent;
  bundleBtn.textContent = isEn ? "Adding bundle to cart... ⏳" : "جاري الإضافة للسلة... ⏳";
  bundleBtn.disabled = true;


  // Add all selected items simultaneously using Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json())
  .then(data => {
    if (discountCode) {
      // Call the discount URL to apply the Shopify cookie automatically
      return fetch(`/discount/${encodeURIComponent(discountCode)}`).then(() => data).catch(() => data);
    }
    return data;
  })
  .then(data => {
    const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
    bundleBtn.textContent = isEn ? "Bundle added successfully! 🎉" : "تمت إضافة الباقة بنجاح! 🎉";
    bundleBtn.style.backgroundColor = "#def71d";
    bundleBtn.style.color = "#0a0a0a";
    
    // Refresh cart drawer if openCartDrawer exists
    if (typeof openCartDrawer === 'function') {
      // Small timeout to let Shopify update database
      setTimeout(() => {
        // Fetch fresh cart status
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const badge = document.getElementById("CartBadge");
          if (badge) badge.textContent = cart.item_count;
          openCartDrawer();
          
          // Revert button status
          setTimeout(() => {
            bundleBtn.textContent = oldText;
            bundleBtn.disabled = false;
            bundleBtn.style.backgroundColor = "";
            bundleBtn.style.color = "";
          }, 3000);
        });
      }, 500);
    }
  })
  .catch(error => {
    console.error('Error adding bundle:', error);
    const isEn = window.location.pathname.startsWith('/en') || document.documentElement.lang.startsWith('en');
    bundleBtn.textContent = isEn ? "Sorry, an error occurred. ❌" : "عذراً، حدث خطأ أثناء الإضافة. ❌";
    bundleBtn.disabled = false;
  });

}

function formatMoney(cents) {
  const basePrice = Math.round(cents / 100.0);
  const info = (typeof CURRENCY_RATES !== 'undefined' && CURRENCY_RATES[currentStoreCurrency]) ? CURRENCY_RATES[currentStoreCurrency] : { rate: 1.0 };
  const converted = Math.round(basePrice * info.rate);
  const code = (typeof currentStoreCurrency !== 'undefined') ? currentStoreCurrency : (window.themeCurrency || 'QAR');
  return `${code} ${converted}`;
}




/* ─── STICKY ADD TO CART (MOBILE) ──────────────────── */
(function initStickyCart() {
  function setup() {
    const stickyBar = document.getElementById('StickyAddToCart');
    const mainPurchaseRow = document.querySelector('.section-main-product .purchase-row:not(.sticky-add-to-cart-bar .purchase-row)');
    const mainQtyInput = document.getElementById('ProductQuantity');
    const stickyQtyInput = document.getElementById('StickyProductQuantity');

    if (!stickyBar || !mainPurchaseRow) return;

    // Sync sticky quantity display with main quantity
    if (mainQtyInput && stickyQtyInput) {
      const syncQty = () => { stickyQtyInput.value = mainQtyInput.value; };
      mainQtyInput.addEventListener('change', syncQty);
      mainQtyInput.addEventListener('input', syncQty);
    }

    // IntersectionObserver: show sticky bar when main purchase row scrolls out of view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

    observer.observe(mainPurchaseRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();

function submitProductFormFromSticky() {
  const mainQtyInput = document.getElementById('ProductQuantity');
  const stickyQtyInput = document.getElementById('StickyProductQuantity');
  if (mainQtyInput && stickyQtyInput) {
    mainQtyInput.value = stickyQtyInput.value;
  }
  const form = document.getElementById('ProductForm');
  if (form) {
    form.requestSubmit ? form.requestSubmit() : form.submit();
  }
}

/* ─── DYNAMIC EXCEL SIZE CHART LOADER ──────────────── */
(function initSizeCharts() {
  function setupSizeChart() {
    // Get current product handle - prefer Liquid-injected value for accuracy
    const urlParts = window.location.pathname.split('/');
    const handle = window.productHandle || urlParts[urlParts.length - 1];
    if (!handle) return;

    const url = window.sizeChartsDataUrl || `${window.Shopify?.routes?.root || '/'}assets/size-charts-data.json`;
    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error("HTTP error " + res.status);
        return res.json();
      })
      .then(data => {
        const pData = data[handle];
        if (!pData) return;

        // Check if page direction is RTL/Arabic
        const isAr = document.documentElement.getAttribute('dir') === 'rtl' || document.documentElement.lang.startsWith('ar');
        const headers = isAr && pData.headers_ar ? pData.headers_ar : pData.headers;
        const origHeaders = pData.headers; // Used to fetch keys from row objects

        // Gender-based CTA text
        const isFemale = pData.gender === 'female';
        const ctaText = isAr
          ? (isFemale ? 'اعرفي مقاسك من هنا 📏' : 'اعرف مقاسك من هنا 📏')
          : 'Size Guide 📏';

        // Update accordion button labels with gender-correct text
        ['accordion-size-guide', 'accordion-size-guide-full'].forEach(id => {
          const el = document.getElementById(id);
          if (el) {
            const span = el.querySelector('button span:first-child');
            if (span) span.textContent = ctaText;
          }
        });

        // Populate table (sidebar & full-width elements if they exist)
        const renderTable = (headerRowId, bodyId, accordionId) => {
          const headerRow = document.getElementById(headerRowId);
          const body = document.getElementById(bodyId);
          const accordion = document.getElementById(accordionId);

          if (!headerRow || !body || !accordion) return;

          // Headers
          headerRow.innerHTML = headers.map(h => `
            <th style="padding: 10px; border-bottom: 2px solid var(--color-border); font-weight: 700;">${h}</th>
          `).join('');

          // Body rows
          body.innerHTML = pData.rows.map(row => `
            <tr style="border-bottom: 1px solid var(--color-border);">
              ${origHeaders.map((h, i) => {
                let cellVal = row[h] || "";
                if (i === 0) {
                  // Localize row label if Arabic
                  cellVal = isAr && row["Part/Size_ar"] ? row["Part/Size_ar"] : cellVal;
                }
                const isFirstCol = i === 0;
                return `
                  <td style="padding: 10px; ${isFirstCol ? 'font-weight: 600; text-align: right; background-color: var(--color-bg-alt);' : ''}">${cellVal}</td>
                `;
              }).join('')}
            </tr>
          `).join('');

          // Show the accordion item
          accordion.style.display = 'block';
        };

        renderTable('size-table-headers', 'size-table-body', 'accordion-size-guide');
        renderTable('size-table-headers-full', 'size-table-body-full', 'accordion-size-guide-full');

      })
      .catch(err => console.error("Error loading size chart data:", err));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSizeChart);
  } else {
    setupSizeChart();
  }
  document.addEventListener('shopify:section:load', setupSizeChart);
})();

// Elegant Toast Alert system for Fluidity activewear theme
function showThemeToast(message, duration = 4000) {
  // Remove any existing toasts
  const existingToast = document.getElementById("ThemeToastAlert");
  if (existingToast) {
    existingToast.remove();
  }

  // Create elegant glassmorphic toast
  const toast = document.createElement("div");
  toast.id = "ThemeToastAlert";
  toast.style.cssText = `
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%) translateY(20px);
    background: rgba(10, 10, 10, 0.9);
    border: 1.5px solid var(--color-accent);
    color: var(--color-text);
    padding: 1rem 2rem;
    border-radius: 8px;
    font-family: var(--font-ar);
    font-size: 0.95rem;
    font-weight: 600;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    backdrop-filter: blur(10px);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    opacity: 0;
    pointer-events: none;
    text-align: center;
  `;
  
  toast.innerHTML = `
    <span>⚠️</span>
    <span>${message}</span>
  `;
  
  document.body.appendChild(toast);
  
  // Trigger animation after append
  requestAnimationFrame(() => {
    toast.style.transform = "translateX(-50%) translateY(0)";
    toast.style.opacity = "1";
    toast.style.pointerEvents = "auto";
  });
  
  // Auto-dismiss logic
  setTimeout(() => {
    toast.style.transform = "translateX(-50%) translateY(-20px)";
    toast.style.opacity = "0";
    toast.style.pointerEvents = "none";
    setTimeout(() => {
      toast.remove();
    }, 400);
  }, duration);
}

/* ─── COLLECTION LIVE FILTERING ENGINE ───────────────── */
let currentCollectionFilters = {
  type: 'all',
  value: 'all',
  size: 'all'
};

function initCollectionLiveFilters() {
  const pillsContainer = document.querySelector(".collection-pills-bar");
  const sizeGroup = document.querySelector(".size-filter-group");
  const grid = document.getElementById("CollectionProductGrid");
  if (!grid) return;

  // Category & Gender & Sale Pills click
  if (pillsContainer) {
    pillsContainer.addEventListener("click", (e) => {
      const btn = e.target.closest(".pill-btn");
      if (!btn) return;
      
      pillsContainer.querySelectorAll(".pill-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      currentCollectionFilters.type = btn.getAttribute("data-filter-type") || 'all';
      currentCollectionFilters.value = btn.getAttribute("data-filter-value") || 'all';
      delete currentCollectionFilters.gender;
      delete currentCollectionFilters.category;
      applyCollectionFilters();
    });
  }

  // Size Filter Buttons click
  if (sizeGroup) {
    sizeGroup.addEventListener("click", (e) => {
      const btn = e.target.closest(".size-btn");
      if (!btn) return;

      sizeGroup.querySelectorAll(".size-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      currentCollectionFilters.size = (btn.getAttribute("data-size") || 'all').toLowerCase();
      applyCollectionFilters();
    });
  }

  // Auto-activate Gender, Sale, or Category filter from URL params / hash / collection pathname
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const filterParam = (urlParams.get('filter') || '').toLowerCase();
    const hash = window.location.hash.toLowerCase();
    const pathname = window.location.pathname.toLowerCase();

    let targetType = '';
    let targetValue = '';

    if (filterParam === 'men' || filterParam === 'male' || filterParam === 'رجال' || pathname.includes('/collections/men')) {
      targetType = 'gender';
      targetValue = 'men';
    } else if (filterParam === 'women' || filterParam === 'female' || filterParam === 'نساء' || pathname.includes('/collections/women')) {
      targetType = 'gender';
      targetValue = 'women';
    } else if (filterParam === 'sale' || filterParam === 'offers' || filterParam === 'عروض' || hash === '#sale' || hash === '#offers') {
      targetType = 'sale';
      targetValue = 'true';
    } else if (filterParam === 'tops') {
      targetType = 'category';
      targetValue = 'tops';
    } else if (filterParam === 'bottoms') {
      targetType = 'category';
      targetValue = 'bottoms';
    } else if (filterParam === 'men-tops') {
      currentCollectionFilters = { type: 'combined', gender: 'men', category: 'tops', size: 'all' };
    } else if (filterParam === 'men-bottoms') {
      currentCollectionFilters = { type: 'combined', gender: 'men', category: 'bottoms', size: 'all' };
    } else if (filterParam === 'women-tops') {
      currentCollectionFilters = { type: 'combined', gender: 'women', category: 'tops', size: 'all' };
    } else if (filterParam === 'women-bottoms') {
      currentCollectionFilters = { type: 'combined', gender: 'women', category: 'bottoms', size: 'all' };
    }

    if (pillsContainer) {
      if (targetType) {
        currentCollectionFilters.type = targetType;
        currentCollectionFilters.value = targetValue;
        
        const matchingPill = pillsContainer.querySelector(`[data-filter-type="${targetType}"][data-filter-value="${targetValue}"]`);
        if (matchingPill) {
          pillsContainer.querySelectorAll(".pill-btn").forEach(b => b.classList.remove("active"));
          matchingPill.classList.add("active");
        }
      } else if (currentCollectionFilters.type === 'combined') {
        // Highlight category pill for combined filter
        const catPill = pillsContainer.querySelector(`[data-filter-type="category"][data-filter-value="${currentCollectionFilters.category}"]`);
        if (catPill) {
          pillsContainer.querySelectorAll(".pill-btn").forEach(b => b.classList.remove("active"));
          catPill.classList.add("active");
        }
      }
    }

    applyCollectionFilters();
  } catch (err) {
    console.error("Filter URL parsing error:", err);
  }
}

function applyCollectionFilters() {
  const items = document.querySelectorAll(".collection-product-item");
  const resetBtn = document.getElementById("ResetFiltersBtn");
  const countEl = document.getElementById("VisibleProductCount");
  const noResultsEl = document.getElementById("NoFilterResults");
  const grid = document.getElementById("CollectionProductGrid");

  let visibleCount = 0;
  const isFiltered = (currentCollectionFilters.type !== 'all' && currentCollectionFilters.value !== 'all') || (currentCollectionFilters.size !== 'all');

  if (resetBtn) {
    resetBtn.style.display = isFiltered ? "inline-flex" : "none";
  }

  items.forEach(item => {
    const gender = item.getAttribute("data-gender") || 'unisex';
    const category = item.getAttribute("data-category") || 'other';
    const sizes = (item.getAttribute("data-sizes") || '').toLowerCase().split(' ').filter(Boolean);
    const isSale = item.getAttribute("data-sale") === 'true';

    let matchesType = true;
    if (currentCollectionFilters.type === 'gender') {
      matchesType = (gender === currentCollectionFilters.value);
    } else if (currentCollectionFilters.type === 'category') {
      matchesType = (category === currentCollectionFilters.value);
    } else if (currentCollectionFilters.type === 'sale') {
      matchesType = isSale;
    } else if (currentCollectionFilters.type === 'combined') {
      matchesType = (gender === currentCollectionFilters.gender) && (category === currentCollectionFilters.category);
    } else if (currentCollectionFilters.type === 'all') {
      matchesType = true;
    }

    let matchesSize = true;
    if (currentCollectionFilters.size !== 'all') {
      matchesSize = sizes.includes(currentCollectionFilters.size);
    }

    if (matchesType && matchesSize) {
      item.classList.remove("filter-hidden");
      visibleCount++;
    } else {
      item.classList.add("filter-hidden");
    }
  });

  if (countEl) {
    countEl.textContent = visibleCount;
  }

  if (noResultsEl) {
    if (visibleCount === 0 && items.length > 0) {
      noResultsEl.style.display = "block";
      if (grid) grid.style.display = "none";
    } else {
      noResultsEl.style.display = "none";
      if (grid) grid.style.display = "grid";
    }
  }
}

function resetAllCollectionFilters() {
  currentCollectionFilters = { type: 'all', value: 'all', size: 'all' };
  
  const pills = document.querySelectorAll(".collection-pills-bar .pill-btn");
  pills.forEach((p, idx) => {
    if (idx === 0) p.classList.add("active");
    else p.classList.remove("active");
  });

  const sizeBtns = document.querySelectorAll(".size-filter-buttons .size-btn");
  sizeBtns.forEach(b => {
    if (b.getAttribute("data-size") === 'all') b.classList.add("active");
    else b.classList.remove("active");
  });

  applyCollectionFilters();
}

/* ─── MULTI-CURRENCY CONVERTER ENGINE ─────────────────── */
const CURRENCY_RATES = {
  QAR: { flag: '🇶🇦', rate: 1.0, symbol: 'ر.ق' },
  SAR: { flag: '🇸🇦', rate: 1.03, symbol: 'ر.س' },
  AED: { flag: '🇦🇪', rate: 1.01, symbol: 'د.إ' },
  KWD: { flag: '🇰🇼', rate: 0.084, symbol: 'د.ك' },
  BHD: { flag: '🇧🇭', rate: 0.103, symbol: 'د.ب' },
  OMR: { flag: '🇴🇲', rate: 0.106, symbol: 'ر.ع' },
  USD: { flag: '🇺🇸', rate: 0.275, symbol: '$' }
};

let currentStoreCurrency = localStorage.getItem('fluidity_currency') || 'QAR';

function toggleCurrencyDropdown(e) {
  if (e) e.stopPropagation();
  const menu = document.getElementById('CurrencyDropdownMenu');
  if (menu) {
    menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
  }
}

document.addEventListener('click', () => {
  const menu = document.getElementById('CurrencyDropdownMenu');
  if (menu) menu.style.display = 'none';
});

function selectSiteCurrency(code, flag, rate) {
  currentStoreCurrency = code;
  localStorage.setItem('fluidity_currency', code);
  
  const flagEl = document.getElementById('HeaderCurrencyFlag');
  const codeEl = document.getElementById('HeaderCurrencyCode');
  if (flagEl) flagEl.textContent = flag;
  if (codeEl) codeEl.textContent = code;

  const menu = document.getElementById('CurrencyDropdownMenu');
  if (menu) menu.style.display = 'none';

  updateAllDOMPrices();
  if (typeof renderCart === 'function') renderCart();
}

function updateAllDOMPrices() {
  const currencyInfo = CURRENCY_RATES[currentStoreCurrency] || CURRENCY_RATES.QAR;
  const rate = currencyInfo.rate;
  const code = currentStoreCurrency;

  const priceSelectors = [
    '.product-price-current',
    '.product-price-compare',
    '.price-current',
    '.price-compare',
    '.hfc-price',
    '.hfc-price-compare',
    '.hotspot-card-price',
    '.hotspot-card-compare'
  ];

  document.querySelectorAll(priceSelectors.join(',')).forEach(el => {
    let basePrice = el.getAttribute('data-base-price');
    if (!basePrice) {
      const cleanText = el.textContent.replace(/[^\d.]/g, '');
      if (cleanText && !isNaN(parseFloat(cleanText))) {
        basePrice = parseFloat(cleanText);
        el.setAttribute('data-base-price', basePrice);
      }
    }

    if (basePrice) {
      const numBase = parseFloat(basePrice);
      const converted = Math.round(numBase * rate);
      el.textContent = `${code} ${converted}`;
    }
  });
}

function initSiteCurrency() {
  const saved = localStorage.getItem('fluidity_currency') || 'QAR';
  const info = CURRENCY_RATES[saved] || CURRENCY_RATES.QAR;
  
  const flagEl = document.getElementById('HeaderCurrencyFlag');
  const codeEl = document.getElementById('HeaderCurrencyCode');
  if (flagEl) flagEl.textContent = info.flag;
  if (codeEl) codeEl.textContent = saved;

  updateAllDOMPrices();
}

// Attach to DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initCollectionLiveFilters();
    initSiteCurrency();
  });
} else {
  initCollectionLiveFilters();
  initSiteCurrency();
}

document.addEventListener("shopify:section:load", () => {
  initCollectionLiveFilters();
  initSiteCurrency();
});





